export const requiredMessage = (name: string) => `${name} is required.`;